import { Directive as h, directive as d } from "../beacon-directive.d/index.js";
import { g as E } from "./uid-HAKIZOcY.js";
const a = class a extends h {
  constructor() {
    super(...arguments), this.uuid = E(), this.slotHasEvent = !1, this.usingParentElement = !1, this.containerSelector = "", this.totalSlottedElements = 0, this.handleSlotchange = (e) => {
      if (e.eventPhase !== 2)
        return;
      const s = e.target, l = s == null ? void 0 : s.assignedElements();
      let t;
      this.totalSlottedElements = l.length, this.containerSelector ? t = this.findContainerElement(s) : t = this.usingParentElement ? s.parentElement : s, this.totalSlottedElements < 1 ? (t == null || t.classList.add(a.defaultClassName), t == null || t.classList.remove(this.hasSlottedClassName)) : (t == null || t.classList.remove(a.defaultClassName), t == null || t.classList.add(this.hasSlottedClassName));
    };
  }
  get hasSlottedClassName() {
    return `has-slotted-${this.uuid}`;
  }
  findContainerElement(e) {
    if (this.containerSelector)
      return e.closest(this.containerSelector);
  }
  /** Create and append a small set of styles when the directive is used. */
  static createStyleElement(e) {
    const s = document.createElement("style");
    s.innerHTML = `.${a.defaultClassName}:not([class*='has-slotted-']) {display: none !important;}`, s.id = a.stylesID, e.appendChild(s);
  }
  update(e, [s = { useParent: !1 }]) {
    const { useParent: l, container: t } = s, i = e.element, o = i.getRootNode(), { parentElement: c } = i;
    l && (this.usingParentElement = !0), t && (this.containerSelector = t);
    const n = {};
    return this.containerSelector ? n.element = this.findContainerElement(i) : l && c ? n.element = c : n.element = i, o.querySelector(`#${a.stylesID}`) || a.createStyleElement(o), this.slotHasEvent || (i.addEventListener("slotchange", this.handleSlotchange), this.slotHasEvent = !0), this.render(n);
  }
  /**
   * The directive takes a single object parameter. If your slot has a parent that dictates styling, then set `useParent` to true. The element to be updated will be handled automatically as either the parent element or the slot directly, but if you have a case where the element you need to hide is higher up, you can pass an HTML element reference into the object.
   *
   * ```ts
   * html`<div class="slot-wrapper">
   *    <slot ${showIfUsed({useParent: true})}></slot>
   * </div>`
   *
   * html`<slot ${showIfUsed()}></slot>`
   * ```
   */
  render({ element: e } = { useParent: !1 }) {
    e && this.totalSlottedElements < 1 && (e.classList.add(a.defaultClassName), e.classList.remove(this.hasSlottedClassName)), e && this.totalSlottedElements >= 1 && e.classList.add(this.hasSlottedClassName);
  }
};
a.defaultClassName = "hide-slot-area", a.stylesID = "show-if-used-directive-styles";
let r = a;
const u = d(r);
export {
  u as s
};
